import { Storage } from './types';

const initialStorage: Partial<Record<keyof Storage, Storage | null | boolean>> = {
  consumer: null,
  activeConsumer: null,
  practice: null,
  provider: null,
  specialty: null,
  visit: null,
  visitContext: null,
  visitSummary: null,
  appointment: null,
  disclaimersAcknowledged: false
};

export const normalizeStorage = (payload: Partial<Storage>) => {
  if (!payload) {
    return initialStorage;
  }

  const keys = Object.keys(payload) as (keyof Storage)[];

  if (!keys.length) {
    return initialStorage;
  }

  return keys.reduce(
    (acc, cur) => {
      acc[cur] = payload[cur] || initialStorage[cur];
      return acc;
    },
    { ...initialStorage }
  );
};
